import { render, staticRenderFns } from "./VehicleDamages.vue?vue&type=template&id=39dc2f39&"
import script from "./VehicleDamages.vue?vue&type=script&lang=js&"
export * from "./VehicleDamages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports